module.exports = __webpack_public_path__ + "img/australia.a808ce0b.svg";